// removed by extract-text-webpack-plugin
module.exports = {"buttonWrapper":"_1N15PxYE"};